export default __webpack_public_path__ + "static/media/logo-vermelho.1a2d2fef.png";